import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faPlus, faMinus, faTimes, faUserAlt, faSignInAlt, faLongArrowAltLeft,
  faFilePdf, faGlobe, faList, faFileAlt, faLongArrowAltRight, faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default () => {
  library.add(faCheck, faPlus, faMinus, faTimes, faUserAlt, faSignInAlt, faLongArrowAltLeft, faFilePdf,
    faGlobe, faList, faFileAlt, faLongArrowAltRight, faDownload)

  //todo - remove useless icons

  Vue.component('font-awesome-icon', FontAwesomeIcon)
}



// WEBPACK FOOTER //
// ./resources/assets/js/_start/app/fontAwesome.js